<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <!-- 首页内容-->
    <div class="content-wrap">
      <!-- 联系方式-->
      <div class="top-wrap">
        <div class="title">全国电影院85折</div>
        <div class="sub-title">最低3这起，推广立即赚钱</div>
        <div class="contact">
          <div>
            <div class="img-box"><img src="../../../assets/img/h5/applet.jpg" alt=""></div>
            <div class="img-tip">购买体验小程序</div>
          </div>
          <div>
            <div class="img-box"><img class="qrcode" src="../../../assets/img/h5/qrcode.jpg" alt=""></div>
            <div class="img-tip">联系商务微信</div>
          </div>
        </div>
      </div>
      <!-- 联系方式-->
      <!-- 为什么选择我们-->
      <div class="advantage-wrap padding-15">
        <div class="advantage-title">为什么选择我们</div>
        <div class="poster-div">
          <img src="../../../assets/img/h5/home_banner.png" alt="">
        </div>
        <div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_discounts_1.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">全国电影票低至3折优惠多多</div>
              <div class="adv-content"><span>特惠购票：</span>以淘票票原价的85-95折购票，任何影院均可享受优惠</div>
              <div class="adv-content"><span>竞价模式：</span>后台超100位供票商竞价，以最低竞价金额出票，低至3折。平均出票时间10分钟内</div>
              <div class="adv-content"><span>秒出票：</span>原价购票，付款秒出票，无须等待</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_cinema_2.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">覆盖全国98%以上的大小影院</div>
              <div class="adv-content">支持全国各地影院，购票建议优选全国连锁影院，如万达、大地、横店、万象、金逸、卢米埃等</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_demand_3.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">6种合作方案、满足各种需求</div>
              <div class="adv-content">专属H5购票链接，分享即赚</div>
              <div class="adv-content">专属公众号购票链接，微信实时推送，体验更佳</div>
              <div class="adv-content">接入【影票】小程序购票，支持公众号外呼</div>
              <div class="adv-content">开通购票分佣系统，支持影票佣金多级分配，粉丝裂变更快</div>
              <div class="adv-content">企业合作，部署整套购票系统，独立运营</div>
              <div class="adv-content">申请开放平台开发者，提供影院、影片、排期、选座、出票接口</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_service_4.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">强大的售货团队7x24小时服务</div>
              <div class="adv-content">解决所有购票售后问题、一站式服务，全自动赚钱，无须担心售后问题，全程为您保驾护航</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 为什么选择我们-->
      <!-- 推广方式-->
      <div class="promotion-wrap padding-15">
        <div class="promotion-title">3种推广方式任您选</div>
        <div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">H5公众号购票链接</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">我要赚钱</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：99元/年 - 499/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">订单分润<span>80% - 100%</span></div>
              <div class="pro-des-div">支持微信服务号模版推送</div>
              <div class="pro-des-div">轻松对接后即可推广，粉丝变现最佳选择</div>
              <div class="pro-des-div">放映2小时后结算</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">小程序购票链接</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">我要赚钱</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：99元/年-499/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">订单分润<span>80% - 100%</span></div>
              <div class="pro-des-div">需要企业号，独立小程序，支持分销自由比例分佣</div>
              <div class="pro-des-div">快速裂变粉丝</div>
              <div class="pro-des-div">放映2小时后结算</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">API接入</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">我要赚钱</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：3000元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">订单成本价供票（含3%技术服务费）</div>
              <div class="pro-des-div">月订单量达到1000单，全额退还</div>
              <!--              <div class="pro-des-div">全自动快速裂变粉丝</div>-->
              <div class="pro-des-div">适合任何形式，根据业务模式，独立开发APP，小程序，H5等相关产品</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">独立版H5系统</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：5999元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">部署整套购票系统，支持任意公众号生成唯一购票链接</div>
              <div class="pro-des-div">可自主招收H5分销代理，自定义分佣比例</div>
              <div class="pro-des-div">自有域名，自主品牌，收款到自有商户号，仅支付出票成本</div>
              <div class="pro-des-div">灵活定义票价折扣，自主掌握利润比例</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">影票小程序</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：99元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">收费最高99元/年<span>分润70%-90%</span></div>
              <div class="pro-des-div">支持服务号、订阅号呼起小程序</div>
              <div class="pro-des-div">新关注小程序的粉丝都归于你名下</div>
              <div class="pro-des-div">享受二级分佣收益，升级总监再享受团队收益</div>
              <div class="pro-des-div">放映两小时后结算，秒提现</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">独立版小程序系统</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：5999元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">部署整套属于自己的小程序品牌，解析到自己的域名</div>
              <div class="pro-des-div">预存款的合作方式，利润空间100%归你</div>
              <div class="pro-des-div">支持对接n个公众号，订阅号、小程序</div>
              <div class="pro-des-div">灵活定义票价折扣，自主掌握利润空间</div>
            </div>
          </div>
          <!--          <div class="pro-div">-->
          <!--            <div class="pro-title-box">-->
          <!--              <div class="pro-title">入驻成为开发者</div>-->
          <!--              <div class="pro-btn-box">-->
          <!--                <span class="pro-btn" @click="contact()">咨询顾问</span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="league-box">-->
          <!--              <span>免费使用</span>-->
          <!--            </div>-->
          <!--            <div class="pro-des-box">-->
          <!--              <div class="pro-des-div">按成本价提供稳定票源，市场最低价，绝无仅有！</div>-->
          <!--              <div class="pro-des-div">提供影票、影院、座位分布、下单API</div>-->
          <!--              <div class="pro-des-div">根据你的业务自由组装数据，自由开发购票页面</div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <!-- 推广方式-->
      <!-- 加入我们赚佣金-->
      <div class="joinus-wrap padding-15">
        <div class="joinus-title">加入我们 赚取佣金</div>
        <div class="step-title">简单3步，轻松推广获取佣金</div>
        <div class="step-img">
          <!-- <img src="../../../assets/img/h5/home_icon_buzhou.png" alt=""> -->
          <div class="step-img-box">
            <div>
              <img src="../../../assets/img/h5/home_icon_register_1.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_arrow.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_getcode_2.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_arrow.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_earn_3.png" alt="">
            </div>
          </div>
          <div class="step-text">
            <div>注册账号</div>
            <div>申请广告并获取代码</div>
            <div>赚取佣金</div>
          </div>
        </div>
      </div>
      <!-- 加入我们赚佣金-->
      <!-- 底部-->
      <div class="footer-wrap padding-15">
        <div class="footer-box">
          <div class="footer-tag">
            <span>关于我们</span>
            <span>法律声明</span>
            <span>廉政举报</span>
            <span>友情链接</span>
          </div>
          <div class="copyright">© 2020-2030 shoutu.com 版权所有 ICP：闽DSS2-487545</div>
        </div>
      </div>
      <!-- 底部 -->
    </div>
    <!-- 首页内容-->
    <Contact ref="Contact" />
    </Contact>
  </div>
</template>

<script>
import Nav from '@/components/h5/Nav.vue'
import Contact from '@/views/h5/home/modal/Contact'
export default {
  name: 'Home',
  components: {
    Nav,
    Contact
  },
  data() {
    return {}
  },
  created() {
    if (this.$route.query.invite_code) {
      let inviteCode = this.$route.query.invite_code
      localStorage.setItem('inviteCode', inviteCode)
    }
  },
  methods: {
    // 联系我们
    contact: function () {
      this.$refs.Contact.init(true)
    },
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  position: absolute;
  width: 100%;

  .top-wrap {
    min-height: 400px;
    background-image: url(../../../assets/img/h5/home_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    color: #FFFFFF;
    text-align: center;
    padding: 60px 0;

    .title {
      font-size: 34px;
      padding: 10px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .sub-title {
      font-size: 18px;
      padding-bottom: 40px;
      font-family: Alibaba-PuHuiTi-R;
    }

    .contact {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      padding: 0 20px;

      .img-box {
        width: 110px;
        height: 110px;
        background: #FFFFFF;

        img {
          width: 98px;
          height: 98px;
          margin-top: 6px;
        }

        .qrcode {
          width: 110px;
          height: 110px;
          margin-top: 0px;
        }
      }

      .img-tip {
        padding-top: 10px;
        font-family: Alibaba-PuHuiTi-R;
      }
    }
  }

  .advantage-wrap {
    background: #FFFFFF;

    .advantage-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding-top: 10px;
      font-family: Alibaba-PuHuiTi-M;
    }

    .poster-div {
      padding: 25px 0;

      img {
        width: 100%;
      }
    }

    .adv-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 25px;

      .adv-img {
        width: 40px;
      }

      .adv-text {
        padding-left: 10px;

        .adv-title {
          color: #222222;
          font-size: 16px;
          padding: 2px 0;
          font-family: Alibaba-PuHuiTi-M;
        }

        .adv-content {
          color: #999999;
          font-size: 13px;
          line-height: 23px;
          font-family: Alibaba-PuHuiTi-R;

          span {
            color: #666666;
          }
        }
      }
    }
  }

  .promotion-wrap {
    background: #F3F3F3;
    font-family: Alibaba-PuHuiTi-R;

    .promotion-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding: 20px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .pro-div {
      background: #FFFFFF;
      padding: 15px;
      margin-bottom: 15px;

      .pro-title-box {
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .pro-title {
          font-size: 16px;
          color: #222222;
          font-family: Alibaba-PuHuiTi-M;
        }

        .pro-btn-box {
          font-size: 14px;
          color: #FFFFFF;

          .pro-btn {
            background: #FF8622;
            padding: 5px 10px;
          }
        }
      }

      .league-box {
        font-size: 12px;
        color: #FF8622;
        letter-spacing: 0;
        text-align: justify;
        margin: 2px 0 5px 0;

        span {
          background: #FFF8F2;
          padding: 2px 6px;
        }
      }

      .pro-des-box {
        color: #999999;
        font-size: 13px;
        line-height: 20px;

        .pro-des-div span {
          color: #FF4F76;
        }
      }
    }
  }

  .joinus-wrap {
    background: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R;

    .joinus-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding: 20px 0 10px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .step-title {
      color: #666666;
      font-size: 14px;
      padding-bottom: 20px;
    }

    .step-img {
      padding: 20px 8px;

      .step-img-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        img {
          width: 100%;
        }
      }

      .step-text {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        font-size: 12px;
        letter-spacing: 0;
        padding-top: 10px;
        color: #666666;
      }
    }
  }

  .footer-wrap {
    background: #333333;
    font-family: "microsoft yahei";

    .footer-box {
      padding: 30px 8px;

      .footer-tag {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: #ffffff;
      }

      .copyright {
        padding-top: 20px;
        font-size: 12px;
        color: #999999;
        text-align: center;
      }
    }
  }
}

.padding-15 {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/home/Index.vue